import createReducer from '../utils/createReducer';
import actions from './actions';

const initialState = {};

const actionHandlers = {};

actionHandlers[actions.SET_CURRENT_TRIPBOARD] = (state, {payload}) => {
    const newState = {
        ...state,
        currentBoardId: payload.boardId
    };
    return newState;
};

export default createReducer(actionHandlers, initialState);



// WEBPACK FOOTER //
// ./src/universal/tripboard/current-tripboard-reducer.js